<template>
	<div class="slides">
		<h2>Слайды</h2>
		<btn l='Добавить слайд' i='plus' @press="create()" size="medium"/>
		<hr/>
		<i-list :fields="fields" :data="slides" @input="edit"/>
		<modal title="Перевод +" name="slide-edit" :height="420" :noFooter="false">
			<div style="padding:6px">
				<i-form :data="currentSlide" :scheme="formScheme" @input="(data)=>{setSlides(data)}" :showSaveButton="false"/>
			</div>
			<div slot="footer">
        <btn l="Удалить"  t='d' s='m'  i='trash' @press="remove" pull='left'></btn>
        <btn l="Сохранить" t='s' s='m'  i='save' @press="saveForm" pull='right'></btn>
        <btn l="Отмена" t='df' s='m'  i='times' @press="cancel" pull='right'></btn>
			</div>
		</modal>
	</div>
</template>

<script>
export default {
  name: 'slides',
  methods:{
    cancel(){this.$store.commit('modalClose','slide-edit');},
    saveForm(){_i.bus.$emit('save-form');},
    remove(){
      this.$store.dispatch("slidesRemoveCRUD",this.currentSlide._id);
      this.$store.commit('modalClose', "slide-edit");
    },
  	edit(tr){
  		this.currentSlide = tr;
  		console.log(this.currentSlide);
  		this.$store.commit('modalOpen', "slide-edit");
  	},
  	create(){
  		this.currentSlide = {};
  		this.$store.commit('modalOpen', "slide-edit");
  	},
  	setSlides(slide){
      this.$store.dispatch("slidesSaveCRUD",slide);
      this.$store.commit('modalClose', "slide-edit");
  		//console.log("slides:",);

  	}
  },
  created(){
    _i.crudApi.makeStore(this,'slides','content/slides')
  },
  computed:{
  	slides(){
  		return this.$store.state.slides.list;
  	}
  },
  data () {
    return {
    	currentSlide:{},
    	formScheme:{
    		"image": {
		        "type": "image",
		        "label": "Изображение",
		        "required":true
		    },
    		"ru": {
		        "type": "string",
		        "label": "Текст на русском",
		        "required":true
		    },
    		"kz": {
		        "type": "string",
		        "label": "Текст на Казахском",
		        "required":true
		    },
    		"en": {
		        "type": "string",
		        "label": "Текст на Английском",
		        "required":true
		    }
    	},
    	fields:[
    		{label:'№',type:'index'},
        {label:'Фон',name:'image',type:'image'},
    		{label:'Руский',name:'ru'},
    		{label:'Казахский',name:'kz'},
    		{label:'Английский',name:'en'}
    	]
    }
  }
}
</script>

<style lang="css" scoped>
.slides{
	padding:6px 12px;
}
</style>